export enum PaymentProviderType {
  Default = 'Default',
  Braintree = 'Braintree',
  PayPal = 'PayPal',
  Nexio = 'Nexio',
  Kushki = 'Kushki',
}
